import { call, put, takeEvery } from 'redux-saga/effects';
import { BrandTypes } from './actionTypes';
import * as url from '../../helpers/url_helper';
import apiFetch from '../../fetch';

import { getBrandSuccess, getBrandFailed } from './actions';
import { updateStyleDocument } from '../../helpers/tools_helper';

function* getBrand() {
  try {
    const response = localStorage.getItem('brand') || '{}';
    yield put(getBrandSuccess(JSON.parse(response)));
  } catch (error) {
    yield put(getBrandFailed(error));
  }
}

function* brandByNetwork({ payload }: any): any {
  const path = url.API_URL;
  let defaultNetworkId = 37370;
  if (path.indexOf('dosanbackend') > -1) {
    defaultNetworkId = 36451;
  }
  const networkId = payload.networkId
    ? Number(payload.networkId)
    : defaultNetworkId;
  const query = `
  query {
    getClientByNetworkid(networkId:${networkId}) {
      id
      name
      email
      company
      description
      enabled
      logo
      logoSmall
      urlHome
      urlLogin
      urlFavicon
      urlLoading
      primaryColor
      secondaryColor
      primaryDarkColor
      secondaryDarkColor
      sidebarBgColor
      headerBgColor
      headerDarkBgColor
      modalHeaderBackground
      modalHeaderTitle
      modalHeaderText
      isMilestoneBackground
      isMilestoneCircle
      isMilestoneText
      modalBodyBackground
      modalBodyTitle
      modalBodyText
      modalTotalBackground
      modalTotalText
      urlImgBanner
      urlLinkBanner
    }
  }`;

  const opts = {
    authRequired: false,
    body: {
      query,
      //variables: {user: userApi},
    },
    method: 'POST',
  };

  // const casing = 'underscore';
  const resp = yield call(apiFetch, path, opts);
  const responseBody = resp.body.data.getClientByNetworkid;
  const brand = {
    name: responseBody.name,
    logo: responseBody.logo + `?timestamp=${Date.now()}`,
    small_logo: responseBody.logoSmall + `?timestamp=${Date.now()}`,
    urlHome: responseBody.urlHome + `?timestamp=${Date.now()}`,
    urlLogin: responseBody.urlLogin + `?timestamp=${Date.now()}`,
    urlFavicon: responseBody.urlFavicon + `?timestamp=${Date.now()}`,
    urlLoading: responseBody.urlLoading + `?timestamp=${Date.now()}`,
    urlImgBanner:responseBody.urlImgBanner + `?timestamp=${Date.now()}`,
    urlLinkBanner:responseBody.urlLinkBanner,
    theme: {
      primaryColor: responseBody.primaryColor,
      secondaryColor: responseBody.secondaryColor,
      primaryDarkColor: responseBody.primaryDarkColor,
      secondaryDarkColor: responseBody.secondaryDarkColor,
      sidebarBgColor: responseBody.sidebarBgColor,
      headerBgColor: responseBody.headerBgColor,
      headerDarkBgColor: responseBody.headerDarkBgColor,

      modalHeaderBackground: responseBody.modalHeaderBackground,
      modalHeaderTitle: responseBody.modalHeaderTitle,
      modalHeaderText: responseBody.modalHeaderText,
      isMilestoneBackground: responseBody.isMilestoneBackground,
      isMilestoneCircle: responseBody.isMilestoneCircle,
      isMilestoneText: responseBody.isMilestoneText,
      modalBodyBackground: responseBody.modalBodyBackground,
      modalBodyTitle: responseBody.modalBodyTitle,
      modalBodyText: responseBody.modalBodyText,
      modalTotalBackground: responseBody.modalTotalBackground,
      modalTotalText: responseBody.modalTotalText
    },
  };
  localStorage.setItem('brand', JSON.stringify(brand));
  yield put(getBrandSuccess(brand));
  updateStyleDocument();
}

function* brandSaga() {
  yield takeEvery(BrandTypes.GET_BRAND, getBrand);
  yield takeEvery(BrandTypes.GET_BRAND_BY_NETWORK, brandByNetwork);
}

export default brandSaga;
